import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import { HomeUpdatedPackTick } from "../../../app-constants";
function Packages(props) {
  return (
    <section className="tekrevol__pack overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Launched Apps">
              <h2>
                Launched Over 200 Projects – For{" "}
                <br className="d-xl-block d-none" />
                All-Sized Businesses
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center ">
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="mb-lg-0 mb-4"
          >
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Startups</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Rapid Prototyping
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    MVP Development
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    POC Development
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            sm={6}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="mb-lg-0 mb-4"
          >
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">SMBs</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Custom Software Development
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Digital Marketing Solutions
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    App Maintenance and Fixes
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="serv-item h-100">
              <div className="serv-inner tekrevol_gray_bg">
                <div className="sub-title">For</div>
                <div className="title">Enterprises</div>
                <ul>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Enterprise Software Solutions
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    Cloud Implementation Services
                  </li>
                  <li>
                    <div className="img">{HomeUpdatedPackTick}</div>
                    DevOps Services
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Packages;
